module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CH-098acc4b5e5c94b67e31c0bf0c18c3c0.png";